import React, { Component } from "react"
import { connect } from 'react-redux'
import OrderCreateForm from "../Order/OrderCreateForm";
import Confirm from "../Order/confirm";
import PageSpinner from "../PageSpinner";

class Order extends Component {
    orderCreated = (responseData) => {
        this.setState({ OrderState: 1, data: responseData, Loading:false });
        // this.props.history.push({
        //     data: { authorized:true, total:10},
        //     pathname: '/receipt'
        // })
    };
    orderLoading = (isLoading) => {
        this.setState({ ...this.state, Loading: isLoading });
    };

    newOrder = () => {
        this.setState({ OrderState: 0, data: {} });
    }
    componentDidMount() {
    }
    constructor(props) {
        super(props);
        this.state = {
            OrderState: 0, data: {}, Loading:false
        };
    }
    render() {
        return (
            <>
                {(this.state.OrderState == 0 && this.state.Loading == false) && (< OrderCreateForm complete={this.orderCreated} loading={this.orderLoading} />)}
                {(this.state.OrderState == 1 && this.state.Loading == false) && (< Confirm complete={this.newOrder} data={this.state.data} />)}
               
            </>
        );
    }
}


const mapStateToProps = state => {
    return { session: state.session }
}

export default connect(mapStateToProps)(Order);
